import axios from "../helpers/axios";
// import fs from "fs";
export const Files = {
  existFile: async (data = {}, callback) => {
    const { url, validate_url = "" } = data;
    await axios
      .get(url)
      .then(async ({ data }) => {
        if (validate_url.trim() != "") {
          await this.dowload({ url }, (response) => {
            return callback(response);
          });
        } else {
          return callback({
            success: data.messageT == "S" ? true : false,
            message: data.message,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        return callback({
          success: false,
          message: "El adjunto no existe",
        });
      });
  },
  dowload: async (data = {}, callback) => {
    const {
      url,
      filename = "filename",
      method = "GET",
      responseType = "blob",
    } = data;
    if (!url)
      return {
        success: false,
        message: "Falta agregar url para descargar",
      };

    await axios({ url, method, responseType })
      .then((response) => {
        if (response.status == 200) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", filename);
          document.body.appendChild(fileLink);
          fileLink.click();

          return callback({
            success: true,
            message: "Se descargó el adjunto",
          });
        } else {
          return callback({
            success: false,
            message: "Ocurrio error al descargar, Intenta mas tarde.",
          });
        }
      })
      .catch(() => {
        return callback({
          success: false,
          message: "Ocurrio error al descargar, Intenta mas tarde.",
        });
      });
  },
  downloadFetch: async (data = {}) => {
    const {
      url,
      filename = "filename",
      method = "GET",
      // responseType = "blob",
    } = data;

    if (!url) {
      return {
        success: false,
        message: "Falta agregar url para descargar",
      };
    }

    try {
      const response = await fetch(url, { method });

      if (!response.ok) {
        return {
          success: false,
          message: "Ocurrio error al descargar, Intenta mas tarde.",
        };
      }

      const blobData = await response.blob();

      var fileURL = window.URL.createObjectURL(blobData);
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", filename);
      document.body.appendChild(fileLink);
      fileLink.click();

      return {
        success: true,
        message: "Se descargó el adjunto",
      };
    } catch (error) {
      return {
        success: false,
        message: "Ocurrio error al descargar, Intenta mas tarde.",
      };
    }
  },
  preview: async (req = {}, res) => {
    const { url, method = "GET", responseType = "arraybuffer" } = req;
    if (!url)
      return res({
        success: false,
        message: "Falta agregar url para descargar",
      });

    await axios({ url, method, responseType })
      .then((response) => {
        if (response.status == 200) {
          //let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          // let raw = Buffer.from(response.data).toString("base64");
          // return "data:" + image.headers["content-type"] + ";base64," + raw;

          // return res({
          //   success: true,
          //   url: fileURL,
          //   message: "Se descargó el adjunto",
          // });
        } else {
          return res({
            success: false,
            url: null,
            message: "Ocurrio error al descargar, Intenta mas tarde.",
          });
        }
      })
      .catch(() => {
        return res({
          success: false,
          url: null,
          message: "Ocurrio error al descargar, Intenta mas tarde.",
        });
      });
  },
};
